import React, { useEffect, useState } from 'react';
import '../styles/WeatherConditions.scss';
import Spinner from './Spinner';
import weatherIcon from '../assets/icons/weather-icon.png';
import directionArrow from '../assets/icons/direction-arrow.png';
import axios from 'axios';

export default function WeatherConditions(props) {
    const {
        coordinates,
        parentWeatherData
    } = props;

    const [weatherData, setWeatherData] = useState(null);

    const getWeatherData = () => {
        if (parentWeatherData) {
            setWeatherData(parentWeatherData)
        } else {
            axios.get(`https://firewatch-api.space-eyes.com/weather/current?lat=${coordinates[0]}&long=${coordinates[1]}`)
            .then((response) => {
                console.log('weather api called', response.data);
                setWeatherData(response.data);
            }).catch((err) => {
                console.log(err);
            });
        }
    }

    useEffect(() => {
        getWeatherData();
    }, [coordinates]);

    const getWindDirection = (degrees) => {
        const blowingToDeg = (degrees + 180) % 360;
    
        if (blowingToDeg >= 337.5 || blowingToDeg < 22.5) return 'North';
        if (blowingToDeg >= 22.5 && blowingToDeg < 67.5) return 'North-East';
        if (blowingToDeg >= 67.5 && blowingToDeg < 112.5) return 'East';
        if (blowingToDeg >= 112.5 && blowingToDeg < 157.5) return 'South-East';
        if (blowingToDeg >= 157.5 && blowingToDeg < 202.5) return 'South';
        if (blowingToDeg >= 202.5 && blowingToDeg < 247.5) return 'South-West';
        if (blowingToDeg >= 247.5 && blowingToDeg < 292.5) return 'West';
        if (blowingToDeg >= 292.5 && blowingToDeg < 337.5) return 'North-West';
    
        return 'Unknown';
    }

    const calculateArrowRotation = (windFromDeg) => {
        const blowingToDeg = (windFromDeg + 180) % 360; 
        return blowingToDeg; 
    };    

    return (
        <div className="weather">
            <div className="weather-header">
                <img src={weatherIcon} className="weather-header-icon" alt="Weather Icon" />
                <span className="weather-header-title">Current Weather Conditions</span>
            </div>
            {weatherData ? (
                <div className="weather-conditions">
                    <div className="weather-conditions-condition">
                        {weatherData && weatherData.wind && weatherData.wind.deg ? (
                            <div className="weather-conditions-condition-data-and-unit-container">
                                <img
                                    src={directionArrow}
                                    className="weather-conditions-condition-data-and-unit-container-wind-arrow-icon"
                                    alt="Direction Arrow"
                                    style={{
                                        transform: `rotate(${calculateArrowRotation(weatherData.wind.deg)}deg)`,
                                        transition: 'transform 0.3s ease',
                                    }}
                                />
                                <span className="weather-conditions-condition-data-and-unit-container-unit-text">{getWindDirection(weatherData.wind.deg)}</span>
                            </div>
                        ) : (
                            <div className="weather-conditions-no-condition">
                                <span className="weather-conditions-no-condition-text">N/A</span>
                            </div>
                        )}
                        <span className="weather-conditions-condition-caption-text">Direction</span>
                    </div>
                    <div className="weather-conditions-condition">
                        {weatherData && weatherData.wind && weatherData.wind.speed ? (
                            <div className="weather-conditions-condition-data-and-unit-container">
                                <span className="weather-conditions-condition-data-and-unit-container-condition-data-text">{(weatherData.wind.speed * 2.237).toFixed(2)}</span>
                                <span className="weather-conditions-condition-data-and-unit-container-unit-text">mph</span>
                            </div>
                        ) : (
                            <div className="weather-conditions-no-condition">
                                <span className="weather-conditions-no-condition-text">N/A</span>
                            </div>
                        )}
                        <span className="weather-conditions-condition-caption-text">Speed</span>
                    </div>
                    <div className="weather-conditions-condition">
                        {weatherData && weatherData.main && weatherData.main.pressure ? (
                            <div className="weather-conditions-condition-data-and-unit-container">
                                <span className="weather-conditions-condition-data-and-unit-container-condition-data-text">{weatherData.main.pressure}</span>
                                <span className="weather-conditions-condition-data-and-unit-container-unit-text">hPa</span>
                            </div>
                        ) : (
                            <div className="weather-conditions-no-condition">
                                <span className="weather-conditions-no-condition-text">N/A</span>
                            </div>
                        )}
                        <span className="weather-conditions-condition-caption-text">Pressure</span>
                    </div>
                    <div className="weather-conditions-condition">
                        {weatherData && weatherData.main && weatherData.main.temp ? (
                            <div className="weather-conditions-condition-data-and-unit-container">
                                <span className="weather-conditions-condition-data-and-unit-container-condition-data-text">
                                    {((weatherData.main.temp - 273.15) * (9/5) + 32).toFixed(1)}°
                                </span>
                                <span className="weather-conditions-condition-data-and-unit-container-unit-text">Fahrenheit</span>
                            </div>
                        ) : (
                            <div className="weather-conditions-no-condition">
                                <span className="weather-conditions-no-condition-text">N/A</span>
                            </div>
                        )}
                        <span className="weather-conditions-condition-caption-text">Temperature</span>
                    </div>
                </div>
            ) : (
                <Spinner />
            )}
        </div>
    );
}